var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRacer1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 431.046,
    height: 787.609,
    viewBox: "0 0 431.046 787.609",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath26",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1165.08 1160.17h299.53V591.839h-299.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath42",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient114",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 669.352 421.612) scale(117.12412)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath124",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient150",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 628.9 442.55) scale(29.67742)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient174",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 669.352 494.715) scale(105.92672)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient198",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 669.352 332.57) scale(47.72195)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient218",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(178.944 667.258 444.184) scale(114.34339)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed785f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce341a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath228",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient258",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(92.50588) rotate(-88.324 10.852 -2.866)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath268",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient294",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(291.22131) rotate(-88.324 3.753 -.706)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc2913",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#bf2a13",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#db5335",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db5335",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath304",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient340",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.116 1208.358 -75.246) scale(470.96426)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b81f0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#c32b0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e86a49",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient364",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-87.51 1111.403 -141.643) scale(26.73491)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath374",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient400",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(174.218 624.51 578.305) scale(40.98273)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient424",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.141 1196.695 -42.457) scale(248.6897)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dd5231",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd5231",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath434",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient470",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-115.184 1006.527 184.454) scale(90.96948)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01d0e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#cd290d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd290d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath480",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient520",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-75.2258 0 0 -75.2258 1338.704 1170.547)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10c0a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#a60f0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60f0b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath530",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient538",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(334.87621 -334.87621) rotate(-88.324 -1.851 -1.681)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath548",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230.69 787.02h66.74V651.519h-66.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient580",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(117.12412 0 0 -117.12412 1338.502 843.211)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath590",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient616",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(29.67742 0 0 -29.67742 1419.405 885.086)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient640",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(105.92672 0 0 -105.92672 1338.502 989.417)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient664",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(47.72195 0 0 -47.72195 1338.502 665.127)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient684",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(112 2.06452 2.06452 -112 1336.893 876.024)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed785f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce341a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath694",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient724",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-92.50588 92.50588) rotate(-88.324 -3.619 12.034)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath734",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient760",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-291.22131 291.22131) rotate(-88.324 -.844 4.027)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc2913",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#bf2a13",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#db5335",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db5335",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath770",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient806",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-470.96426 470.96426) rotate(-88.116 -.277 2.778)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b81f0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#c32b0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e86a49",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient830",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-26.73491 26.73491) rotate(-87.51 -8.499 46.995)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath840",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient866",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(40.7742 4.12903 4.12903 -40.7742 1373.1 1090.735)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient890",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(248.6897 -248.6897) rotate(87.859 5.205 .592)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dd5231",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd5231",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath900",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient936",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(90.96948 -90.96948) rotate(64.816 17.909 5.75)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01d0e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#cd290d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd290d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath946",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient986",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(75.2258 0 0 -75.2258 1338.502 1170.534)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10c0a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#a60f0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60f0b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath996",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1004",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-334.87621) rotate(-88.324 -1.851 -1.681)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1014",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379.78 787.007h66.73V651.506h-66.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1030",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222.7 1101.18h231.03V860.896H1222.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1034",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1453.734 1058.095s-36.167 16.839-39.119 18.348c0 0 2.145-20.897 12.241-31.629 0 0-3.322-3.988-7.452 2.188-4.129 6.177-10.258 8.241-10.258 8.241s14.149-15.972 13.27-17.927c-.878-1.954-29.203 17.774-34.123 27.266-4.92 9.492-9.34 19.468-9.34 19.468s-2.903-1.452-15.807-5.581c-12.903-4.129-47.483-3.613-56.257-4.129-8.775-.516-9.217 9.71-9.217 9.71s-5.368-14.765-8.212-18.553c-2.844-3.789-39.11-31.513-39.11-31.513s7.449 13.031 13.129 13.809c5.679.778 16.845 20.87 17.224 28.096.379 7.225 5.038 25.29 5.038 25.29s-5.691-25.29-8.788-29.42c-3.097-4.129-6.451-14.709-11.354-18.838-4.904-4.129-16.348-14.968-17.594-16-1.245-1.032-4.408-2.937-4.408-2.937l16.817 27.982 3.065 21.664s-4.507-7.825-13.129-10.687c-8.622-2.861-19.443-10.216-22.743-12.538-3.299-2.323-4.905-4.259-4.905-4.259s.245-53.342.472-64.024l4.433 2.218 2.785 27.613.912-21.154s.23 7.477 6.424 14.702c6.193 7.226 14.389 20.187 26.528 23.905 11.762 3.603 44.762 17.328 72.116 15.78 27.356-1.549 45.965-1.878 71.358-13.865 25.393-11.988 34.424-29.417 36.727-40.522 2.303-11.104 2.222-78.473.972-96.272-1.25-17.8-3.166-43.631-3.166-43.631s8.109 34.956 7.336 46.006c-.775 11.051 3.418 143.72 4.135 151.193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1048",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(231.73742 -231.73742) rotate(-1.056 -226.435 -288.54)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1050",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1048)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1070",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(231.73742 -231.73742) rotate(-1.056 -226.435 -288.54)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1096",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1279.82 930.898h128.74v-114.69h-128.74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1100",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1290.982 924.227c17.971.436 34.01 9.047 49.991 6.032 15.98-3.016 60.084-4.819 63.322-8.304 3.239-3.486 8.899-58.518-2.705-78.744-11.605-20.226-23.476-14.729-32.766-22.381-9.29-7.651-64.516-4.906-66.064 1.721-1.549 6.628 8.258 31.869 5.678 38.345-2.582 6.477-19.586-26.556-22.697-27.072-3.11-.516 1.019 43.839-3.11 56.242-4.129 12.403-2.488 32.783-2.488 32.783z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1114",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(128.24087 -128.24087) rotate(-1.056 -364.136 -545.161)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1116",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1114)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1136",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(128.24087 -128.24087) rotate(-1.056 -364.136 -545.161)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.484 1172.07H1099.5V570.226H819.484z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-214.14964 214.14964) rotate(-88.508 -.165 4.937)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(15.35556 0 0 -15.35556 1103.86 674.692)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(161.52376 -161.52376) rotate(87.94 6.628 .002)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(341.73401 -341.73401) rotate(8.588 22.312 15.05)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(127.88548 -127.88548) rotate(8.588 50.475 48.755)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0071bc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-245.33535 245.33535) rotate(-88.649 -.073 4.14)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(68.12904 0 0 -68.12904 984.436 763.79)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0b3128",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(57.67234 -57.67234) rotate(-78.751 1.766 -16.513)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(9.8274 49.41 49.41 -9.8274 1020.535 687.921)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(41.0715 -41.0715) rotate(-78.751 1.899 -23.816)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(30.06596 -30.06596) rotate(-78.751 2.284 -33.015)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(35.71847 -35.71847) rotate(-78.751 1.688 -28.057)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(103.79456 -103.79456) rotate(-57.179 -.735 -11.988)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(78.2751 -78.2751) rotate(-88.986 1.974 -11.145)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.508 771.079h13.622v-54.81h-13.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(87.49757 -87.49757) rotate(-88.986 1.797 -9.92)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(23.37066 0 0 -23.37066 1086.371 819.318)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#1c100f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c100f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(74.4895 -74.4895) rotate(30.385 24.005 20.073)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#006da7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006da7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -81.3434 -81.3434 0 988.952 694.387)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0076c5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076c5",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -54.96774 -54.96774 0 989.79 706.144)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0a4c65",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a4c65",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-255.98512 255.98512) rotate(-88.508 -.383 3.86)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e5068",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-216.07106 216.07106) rotate(-88.508 -.51 4.359)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0070af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#186ec2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186ec2",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-195.33115 195.33115) rotate(-88.508 .202 5.822)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(577.77899) rotate(-90 1.997 .138)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(183.49857 -183.49857) rotate(-89.275 0 -5.645)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#035269",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035269",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050.94 1137.19h39.76v-136.12h-39.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.508 945.968 50.06) scale(214.14964)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-15.35556 0 0 -15.35556 858.789 674.682)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(161.52376 -161.52376) rotate(87.94 6.278 -.335)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-341.73401) rotate(8.588 19.44 -23.194)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-171.412 513.164 410.983) scale(127.88548)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0071bc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(245.33535) rotate(-88.649 3.927 .044)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-68.12904 0 0 -68.12904 978.213 763.78)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0b3128",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-57.67234) rotate(-78.751 -15.25 4.22)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(101.249 188.775 730.548) scale(50.37783)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-41.0715) rotate(-78.751 -21.994 5.297)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-30.06596) rotate(-78.751 -30.355 6.755)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-35.71847) rotate(-78.751 -25.786 5.42)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(122.821 303.207 576.4) scale(103.79456)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-78.2751) rotate(-88.986 -10.563 1.616)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952.522 771.069h13.618v-54.81h-13.618z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(91.014 128.586 809.601) scale(87.49757)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-23.37066 0 0 -23.37066 876.277 819.308)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#1c100f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c100f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-149.615 575.279 219.082) scale(74.48951)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#006da7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006da7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 834.037 -139.66) scale(81.34339)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0076c5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076c5",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -54.96774 54.96774 0 972.858 706.134)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0a4c65",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a4c65",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(255.98512) rotate(-88.508 3.45 -.075)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e5068",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.508 871.024 -65.468) scale(216.07106)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0070af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#186ec2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186ec2",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.508 1020.828 129.962) scale(195.33115)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(268.85062) rotate(-90 3.847 .541)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90.725 -41.483 968.901) scale(183.49857)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#035269",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035269",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.945 1137.18h39.769v-136.12h-39.769z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(168.851 400.629 577.409) scale(36.0349)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#1a5678",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(178.9903 0 0 -178.9903 891.83 955.236)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#424242",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.008 689.708h56.105v-86.735h-56.105z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1066.13 768.86h36.19v-97.837h-36.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.628 1141.46h257.342v-114.32H849.628z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(12.23642 0 0 -12.23642 1053.891 839.46)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "gray",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1055.21 1033.25h4.96V926.789h-4.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-106.46805 106.46805) rotate(-88.508 .012 9.952)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ffe696",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#636144",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636144",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.06 1032.8h17.615V762.402H897.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-270.54063 270.54063) rotate(-88.508 .28 3.632)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ffe696",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#636144",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636144",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 173.659 699.798) scale(180.709)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 281.505 807.666) scale(180.705)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 279.806 701.505) scale(68.8945)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 233.002 874.728) scale(94.3246)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 105.067 748.656) scale(94.0274)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(56.30471 0 0 -56.30471 1044.949 1151.7)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(55.6341 0 0 -55.6341 861.393 1152.586)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(51.61638 0 0 -51.61638 863.718 1153.886)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(179.989 549.83 576.115) scale(51.61638)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.412 1184.05h316.547v-586.3H41.412z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.511 581.232 392.47) scale(195.68098)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -39.22107 39.22107 0 202.603 656.111)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -27.176 27.176 0 207.33 667.874)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 441.383 251.48) scale(37.57926)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 451.99 234.209) scale(15.87097)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c695f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 554.33 401.51) scale(341.85351)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 388.205 292.507) scale(50.35491)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-195.7686) rotate(87.247 1.83 -2.513)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-511.46419) rotate(87.247 1.02 -1.3)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 620.68 465.666) scale(138.65765)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 574.004 462.418) scale(294.77964)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#458800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#407500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407500",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 565.187 454.74) scale(223.64261)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#363029",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#191c0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c0f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-234.561) rotate(87.247 2.06 -2.537)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 615.743 510.564) scale(365.32494)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#326100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#58a200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58a200",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 58.135 492.33) scale(12.9067)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-11.22762 0 0 -11.22762 116.268 981.276)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-27.24143 0 0 -27.24143 105.04 987.493)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-96.028 594.282 523.8) scale(167.11744)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#417600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-109.804 492.895 533.423) scale(88.27635)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-109.804 495.927 537.557) scale(119.58861)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-44.68367 0 0 -44.68367 167.363 1149.128)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(34.73803) rotate(88.848 -14.76 19.192)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5d00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274700",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(88.848 -498.342 692.234) scale(27.12284)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a6800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#284a00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(102.73043) rotate(88.848 -4.504 6.184)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437800",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(195.68098 -195.68098) rotate(88.489 3.265 -1.812)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -38.23526 -38.23526 0 268.155 655.955)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -27.176 -27.176 0 263.202 667.874)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -37.57926 -37.57926 0 281.855 692.862)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -15.87097 -15.87097 0 253.492 686.2)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c695f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(341.8535 -341.8535) rotate(87.247 1.923 -.977)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(50.35491 -50.35491) rotate(87.247 10.78 -3.174)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(195.7686 -195.7686) rotate(87.247 3.035 -1.25)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(511.46419 -511.46419) rotate(87.247 1.48 -.815)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(138.65765 -138.65765) rotate(87.247 5.224 -2.913)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(294.77964 -294.77964) rotate(87.247 2.446 -1.204)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#458800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#407500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407500",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(114.75313 -114.75313) rotate(87.247 5.992 -3.667)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#363029",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#191c0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c0f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(223.64261 -223.64261) rotate(87.247 3.188 -1.545)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#363029",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#191c0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c0f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(234.561 -234.561) rotate(87.247 3.065 -1.482)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(365.32494 -365.32494) rotate(87.247 2.112 -1.091)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#326100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#58a200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58a200",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(12.9067 0 0 -12.9067 355.488 984.658)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(11.22762 0 0 -11.22762 355.49 981.276)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(27.24143 0 0 -27.24143 366.717 987.493)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(167.11744 -167.11744) rotate(83.972 4.894 -2.383)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#417600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(88.27635 -88.27635) rotate(70.196 11.27 -4.143)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(119.58861 -119.58861) rotate(70.196 8.369 -3.094)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(44.68367 0 0 -44.68367 304.395 1149.128)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-34.73803 34.73803) rotate(88.848 -21.55 12.263)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5d00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274700",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-27.12284 27.12284) rotate(88.848 -27.07 16.649)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a6800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#284a00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-102.73043 102.73043) rotate(88.848 -6.8 3.84)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437800",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.33 1136.69h213.237v-57.08H138.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.814 1127.877c.398-.968-14.613-3.459-17.193-3.31-2.581.149-7.658 3.31-7.658 3.31s-33.489 6-50.077 4.774-40.846-2.056-52.201.165c-11.354 2.223-26.838 6.17-35.613 2.132-8.774-4.039-47.741-50.536-47.741-50.536l.372-4.799s31.73 21.216 70.66 19.549c38.929-1.668 105.674-8.361 112.451-12.123 6.778-3.763 19.011-4.13 19.011-4.13s3.521-2.064 5.872 4.13c2.351 6.193 5.157 16.677 4.846 21.113-.31 4.435-.696 14.068-.696 14.068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4542",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(204.85174 -204.85174) rotate(9.462 33.385 1.606)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4542)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(204.85174 -204.85174) rotate(9.462 33.385 1.606)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.28 961.918h162.55V804.976H157.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.547 961.588s-27.152.743-35.281 0c-8.129-.743-6.968-7.753-17.226-10.442-10.258-2.688-64.897-4.065-70.742 0-5.844 4.067-13.451 11.208-17.516 8.905-4.065-2.303-21.103-19.335-21.487-38.69-.384-19.355 6.599-43.162 7.107-65.452.509-22.29-.251-45.814 0-47.472.251-1.657 10.592 21.311 12.39 31.118 1.796 9.806 4.119 5.935 4.893-8 .774-13.936-11.419-34.792 6.678-23.202 18.096 11.588 53.129 24.75 63.096 24.75 9.968 0 29.904-1.807 29.613 6.452-.29 8.257 6.042 26.153 9.581 16.354 3.539-9.798 9.301-22.806 13.65-11.968 4.35 10.839 17.622 102.906 15.244 117.647"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4604",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(162.55013 0 0 -162.55013 157.28 883.447)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4604)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(162.55013 0 0 -162.55013 157.28 883.447)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.983 755.773h40.352V633.239h-40.352z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.219 1175.49h296.777V577.234H425.219z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(123.48387 0 0 -123.48387 602.244 864.194)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#524430",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#392a15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392a15",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(84.46748 0 0 -84.46748 605.873 753.829)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(111.14707 0 0 -111.14707 603.437 979.959)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(255.48856 -255.48856) rotate(89.653 3.167 -.587)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffdd39",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(30.46916 0 0 -30.46916 691.405 861.778)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(62.98678 -62.98678) rotate(88.591 10.712 .18)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#ffde3d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc008",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(74.12726 -74.12726) rotate(13.309 52.641 33.209)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(70.98997 1.7106 1.7106 -70.98997 683.451 916.332)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(41.26448 0 0 -41.26448 684.07 1149.044)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(38.19355 0 0 -38.19355 686.502 1140.936)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b4b4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#967e81",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#7d5f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(34.29031 -34.29031) rotate(88.152 27.623 -6.157)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9d1d3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad959a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(44.54008 -44.54008) rotate(88.152 21.379 -4.861)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#562652",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6c97",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(1.54839 -48 -48 -1.54839 669.74 1209.804)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(1.03226 -144 -144 -1.03226 657.246 1185.821)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#f4b80b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-40.14541 40.14541) rotate(81.87 -23.971 3.954)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bca6af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74545e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(103.49191 -103.49191) rotate(89.286 8.608 -2.516)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc708",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(58.83871 0 0 -58.83871 607.018 1181.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2027",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2630",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(4.78226 0 0 -4.78226 731.663 863.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(18.82398 0 0 -18.82398 716.18 1071.917)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(18.82398 0 0 -18.82398 716.18 1064.497)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(18.82398 0 0 -18.82398 716.18 1056.872)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(28.82387 0 0 -28.82387 725.775 953.722)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(34.37492 0 0 -34.37492 721.018 959.432)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 303.496 432.097) scale(120.3871)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#524430",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#392a15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392a15",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-85.28419 0 0 -85.28419 608.953 753.829)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 304.477 489.98) scale(109.77023)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90.347 756.186 200.948) scale(255.48856)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffdd39",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 261.302 430.889) scale(30.46916)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.409 595.937 66.078) scale(62.98678)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#ffde3d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc008",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-166.691 319.802 384.441) scale(74.12726)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-71.01057) rotate(-1.38 -539.336 303.662)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-41.26448 0 0 -41.26448 529.94 1149.044)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 263.754 570.468) scale(38.19355)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b4b4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#967e81",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#7d5f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.848 811.42 329.413) scale(34.29031)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9d1d3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad959a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.848 816.646 334.243) scale(44.54008)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#562652",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6c97",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-1.54839 -48 48 -1.54839 544.27 1209.804)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90.411 867.057 316.517) scale(144.0037)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#f4b80b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(40.14541) rotate(81.87 -8.851 21.388)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bca6af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74545e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-103.49191) rotate(89.286 2.743 -8.455)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc708",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 303.496 590.565) scale(58.83871)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2027",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2630",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-4.78226 0 0 -4.78226 482.346 863.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-18.82398 0 0 -18.82398 497.83 1071.917)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-18.82398 0 0 -18.82398 497.83 1064.497)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-18.82398 0 0 -18.82398 497.83 1056.872)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-28.82387 0 0 -28.82387 488.235 953.722)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-34.37492 0 0 -34.37492 492.992 959.432)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(3.3638 0 0 -3.3638 632.62 868.21)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(2.638 0 0 -2.638 580.638 868.614)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.631 749.857h17.608v-59.524h-17.608z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.24 1119.83h13.724v-94.96H500.24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.628 1117.54H716.68v-111.37H508.628z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.409 941.968h139.467V803.267H551.409z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.249 753.896h46.792v-95.58h-46.792z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 -1553.441 1576.728)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1189.086 938.52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.182.346-.335.557-.335.557l.342.217L0 0m199.398-282.746l.657 1.815c1.526-.97 3.127-2.183 2.947-3.557v-.002c-1.529.82-2.778 1.434-3.604 1.744m-150.885-1.73c-.18 1.374 1.421 2.587 2.947 3.558l.657-1.815c-.826-.31-2.075-.924-3.604-1.745v.002M19.205-171.464l.004-.027c-.022-.054-.042-.11-.063-.164l.059.188zm213.106-.016l.058-.187c-.021.054-.043.109-.062.163 0 .009.002.018.003.026l.001-.002M251.85.544s-.154-.211-.335-.557l-.007.775zm18.58-.129c-3.707 2.557-13.067 8.657-18.998 12.506-.105 25.109.118 55.427 1.579 68.784 2.71 24.774-1.355 57.291-13.161 86.323-11.807 29.032-33.766 35.985-33.766 35.985v-.001c-14.949 7.916-28.34 11.101-28.34 11.101h.001c-5.875 2.008-11.702 3.743-15.895 4.399-12.263 1.916-29.451 2.125-35.992 2.129v.013c-6.386 0-23.805-.194-36.193-2.13-4.193-.654-10.02-2.39-15.895-4.399l.001.001s-13.391-3.186-28.34-11.101v.001s-21.959-6.953-33.766-35.985C-.142 139.008-4.206 106.492-1.496 81.718-.035 68.36.187 38.042.083 12.934-5.848 9.085-15.209 2.984-18.916.428c-4.399-3.034-5.469-12.014-4.98-15.754 0-.001-.25-1.948.722-1.666 1.528 0 20.952 9.798 23.136 12.846C-.167-17.145-.335-26.18-.335-26.18s1.161-109.527 0-122.362c-1.161-12.836-8.516-78.256-3.871-109.224 4.645-30.967 6.834-56.903 14.062-71.225 0 0 6.455-6.581 10.841-6.581 4.387 0 15.066 2.064 20.566 0 5.493-2.063 22.496-11.076 84.393-11.097v-.013c62.065 0 79.097 9.033 84.596 11.097 5.5 2.064 16.178 0 20.565 0 4.387 0 10.841 6.581 10.841 6.581 7.229 14.322 9.417 40.258 14.063 71.226 4.644 30.967-2.71 96.386-3.871 109.222-1.162 12.836 0 122.363 0 122.363s-.168 9.035-.297 22.034c2.183-3.048 21.607-12.845 23.135-12.845.972-.284.722 1.665.722 1.665.489 3.74-.58 12.719-4.98 15.754"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1402.371 665.953)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#525657",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.316-.478 38.969-20.258 38.969-20.258L41.55-5.29 7.937 12.258s-3.922-.645-4.187-1.29C3.485 10.322 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1441.13 659.314)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#842229",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.123-.653c-.428-2.263-1.851-9.651-2.258-10.127-.482-.564-9.486 4.62-14.136 6.808-4.648 2.189-16.046 7.281-17.337 9.784-1.291 2.504-1.59 6.682-1.59 6.682s-4.309-3.662-4.087-4.565c.22-.904 12.903-18.58 15.096-20.645 2.194-2.064 3.782-8.821 4.665-10.411.883-1.589 10.369-5.719 14.659-5.46 4.289.258 17.48 5.967 17.48 5.967s2.87 10.769 2.949 11.179c.078.41-12.186 11.242-12.186 11.242L-.045-.241"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1419.404 665.127)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292c31",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.144-.182 0-7.303 0-7.303s13.848-7.225 16.344-8.645c2.495-1.419 3.656-1.678 2.624-.645-1.032 1.032-9.677 6.85-10.451 8.199-.775 1.349.774 2.252.129 3.414C8-3.819 0 .826 0 .826z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1407.275 671.76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b3b7b3",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s19.227-10.452 19.613-11.355c.387-.904-5.161-2.693-4.258-3.798.904-1.106 7.097-3.477 7.097-3.477s3.097 6.242 2.322 8.049C24-8.774.903 4.516.903 4.516L-1.154.497z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1451.92 648.534)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d32605",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s.774-8.774 0-9.291c-.774-.516-9.549 0-9.549 0s-2.322-.387-2.322 1.161c0 1.549 1.032 16.202 1.032 16.202s.775.573 1.936-.718C-7.742 6.064 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1444.824 650.856)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-10.193h3.226v9.29z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.835 665.966)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#525657",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.316-.478-38.97-20.258-38.97-20.258L-41.55-5.29l33.612 17.548s3.923-.645 4.188-1.29C-3.485 10.322 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1236.076 659.328)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#842229",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.123-.654c.428-2.263 1.85-9.651 2.258-10.127.481-.564 9.486 4.62 14.135 6.808 4.649 2.19 16.047 7.281 17.338 9.785 1.291 2.503 1.59 6.682 1.59 6.682s4.308-3.663 4.087-4.566c-.22-.904-12.903-18.58-15.096-20.645-2.194-2.064-3.782-8.821-4.665-10.411-.884-1.589-10.369-5.718-14.659-5.46-4.29.258-17.48 5.967-17.48 5.967s-2.871 10.769-2.949 11.18C-15.396-11.032-3.133-.2-3.133-.2L.045-.242"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1257.8 665.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292c31",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.143-.182 0-7.303 0-7.303s-13.847-7.225-16.343-8.645c-2.496-1.419-3.657-1.677-2.625-.645s9.678 6.85 10.452 8.199c.775 1.349-.774 2.252-.129 3.414C-8-3.819 0 .826 0 .826z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.93 671.773)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b3b7b3",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-19.226-10.452-19.612-11.354c-.388-.904 5.161-2.694 4.258-3.799-.904-1.105-7.097-3.477-7.097-3.477s-3.097 6.243-2.322 8.049C-24-8.774-.903 4.516-.903 4.516L1.155.497z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.285 648.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d32605",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.774-8.774 0-9.291c.774-.516 9.548 0 9.548 0s2.323-.387 2.323 1.162c0 1.548-1.032 16.201-1.032 16.201s-.775.573-1.936-.718C7.741 6.064 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1232.382 650.87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-10.193h-3.226v9.29z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient114)",
    stroke: "none",
    d: "M1239.862 1037.532l-17.16-68.47s-1.502-95.548-1.03-98.964c.472-3.414 18.19-104.878 18.19-104.878l47.116-120.093 51.726 3.85v392.344z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath124)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1273.677 719.27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666768",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s5.501 91.048 4.361 94.034c-1.14 2.985-11.141.921-11.141.921S-17.577 61.106-19.568 58.93c-1.993-2.176-4.209-23.281 0-29.757C-15.359 22.696 0 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient150)",
    stroke: "none",
    d: "M1230.392 952.805l-2.268-96.774 19.097-75.355s6.451 5.721 5.676 6.344c-.773.623-11.008 38.817-11.439 51.204l16.342-5.419v5.161l-1.584.535-16.738 5.658s-8.004 116.307-3.873 138.799l-2.816 6.565z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient174)",
    stroke: "none",
    d: "M1248.253 1045.708s-15.96-17.806-15.464-19.355c.496-1.548-.011-32-.011-32l6.443-17.541s19.612-55.234 21.161-56.008c1.548-.774 78.322 9.808 78.322 9.808v24.516s-6.839.947-7.612-1.075c-.775-2.023-3.355-11.313-5.42-12.345-2.065-1.033-59.917-6.451-61.185-6.194-1.266.258-20.88 52.533-21.525 54.009-.644 1.475.388 20.571 16.646 27.797 16.257 7.227 40.257 18.065 79.096 18.065v22.71z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient198)",
    stroke: "none",
    d: "M1296.457 659.672c7.331-2.014 42.247-3.053 42.247-3.053v16.315c-14.323 0-47.429.725-47.429.725s-2.148-11.974 5.182-13.987"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient218)",
    stroke: "none",
    d: "M1232.789 989.523s20.367-46.396 23.076-64.589c2.71-18.194 1.935-57.291 1.935-67.356 0-10.064-8.038-74.475-8.038-74.475l-.09-16.518 10.258-8.103s4.452 42.58 9.096 50.556c4.646 7.976 42.195 5.186 42.195 5.186l29.752-1.874-2.269 122.363c-39.483 0-50.709-3.586-65.793-6.682-15.085-3.097-15.008 6.682-15.008 6.682l-25.114 62.342z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath228)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 641.32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d64829",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-20.774 3.807S-42.71 1.484-43.742 1.903c-1.032.42-30.968-3.193-32.516-3.709-1.549-.516-4.645-5.935-4.645-5.935s21.161-10.065 32.774-12.646c11.613-2.581 46.091-3.336 46.091-3.336L0-22.451z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 655.127)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d52d19",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-40.451s-37.936 97.355-38.323 103.355c0 0 4.062 41.807 6.966 46.645 2.905 4.839-1.934 7.223 71.808 7.223v1.874s-55.848.889-56.429.695c-.58-.193-14.797.273-17.507-10.566-2.709-10.839-6.967-48.58-6.967-48.58l18.967-78.445 20.904-26.459S-47.742.903-48-3.612c-.258-4.517 1.388-6.514 4.646-7.356 3.256-.841 11.742-.121 13.786.079 2.044.201 17.697 4.18 19.246 4.18C-8.774-6.709 0-4.258 0-4.258z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 653.143)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2988a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-38.71s.259-3.822 2.71-5.757c2.452-1.935 1.29-2.452-.129-2.452s-3.225.646-3.613 0c-.387-.645-8 5.936-4.645 5.936 3.355 0 3.44-.226 3.11.649-.331.876-15.497 16.77-16.53 17.157-1.032.387-6.193 4.258-6.193 4.258l-2.58-3.483s-.774-1.291 0-1.936c.773-.645 2.838.387 1.677-1.291-1.161-1.677-33.807-18.58-33.936-20.773-.129-2.195 3.784-8.254 7.893-10.579 4.107-2.325 30.172-9.292 30.172-9.292L0-35.822l-.258 4.13s-78.839 9.676-77.032 12.644c1.807 2.968 18.193 2.323 23.871 4 5.677 1.678 9.677 4 16.774 4.129 7.097.129 19.613-2.064 36.645-2.064z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient258)",
    stroke: "none",
    d: "M1224.779 739.127l-9.3-45.161s11.652-39.096 12.409-40.823l5.913 5.21s27.902 15.42 27.557 18.065c-.346 2.644 5.91 4.703 5.521 5.557-.389.854-7.014 47.087-7.014 47.087s-19.871 15.743-22.968 16.775c-.194.065-.41.095-.646.095-3.543 0-11.472-6.805-11.472-6.805"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.026 677.328)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e99c8f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-42.529-19.716-45.555-29.942c0 0-.166-6.557 1.308-9.182s-.422-2.238-1.314-1.271c-.89.968-3.107 12.968-3.256 13.936-.15.968 9.049 5.896 9.049 5.896S-10.258-1.491-4.064.831c0 0-17.033 47.227-18.968 49.742-1.935 2.517-5.032 8.323-8.709 0-3.678-8.322-6.238-9.096-6.894-24.774-.655-15.677 1.668-24.451-2.01-22.839-3.677 1.613-6.193 10.645-6.193 10.645l-6.774 20.129s-2.129 26.517-1.355 28.065c.774 1.549 7.548 13.935 7.548 13.935s5.807 23.42 6 24.388c.193.967 5.807 15.483 5.807 15.483l9.677-23.612 23.613-69.484L0 3.154z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient294)",
    stroke: "none",
    d: "M1212.511 812.35c-1.161-12.836-8.517-78.255-3.871-109.223 4.646-30.967 6.833-56.904 14.062-71.225 0 0 6.454-6.582 10.841-6.582 4.386 0 15.066 2.065 20.566 0 5.499-2.065 22.53-11.096 84.595-11.096v5.677s-34.451.258-47.613 3.354c-13.161 3.097-45.162 12.131-45.162 12.131s-19.368-1.807-22.457 4.386c-3.09 6.194-1.929 12.129 5.878 16.516 0 0-13.355 70.195-11.549 78.968 1.806 8.774 7.484 13.162 8.258 24.517.774 11.354 4.241 24.209 5.991 29.652 1.751 5.444-1.658 40.025-1.658 40.025l-17.881 105.263s1.161-109.527 0-122.363"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath304)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1230.124 790.998)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#434548",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s.968 15.097-.774 20.516c-1.743 5.42-4.005 11.42-6.648 11.032-2.642-.386-6.127-1.741-6.127-8.516 0-6.774.194-48 0-48.58-.193-.581.775-8.71 4.451 0C-5.42-16.838-1.17-5.078 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1229.35 796.998)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23272b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-4.779-8.322-6.647-8.709c-1.87-.388-3.224 23.225-2.063 24C-7.549 16.064-.193 9.484 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1220.209 763.703)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#696e6f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-1.505 20.705-1.312 24.581c.195 3.876-.209 27.942.648 30.778.856 2.837-.911 1.647-1.588.757-3.221-4.241-1.297-40.047-1.297-40.047s-.509-16.527.482-17.426C-2.077-2.256-1.169-2.584 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient340)",
    stroke: "none",
    d: "M1224.51 1128.934c-11.806-29.032-15.87-61.548-13.16-86.323 2.709-24.774 1.161-107.898 1.161-107.898s14.322-98.037 19.354-143.715c5.032-45.677 36-111.21 37.161-113.67 1.162-2.458 3.098-7.877 3.098-7.877s2.709 2.709 5.419 0c2.71-2.711 20.129-18.582 20.129-18.582s-42.968 113.499-51.871 145.008c-8.904 31.508-13.442 92.331-13.442 92.331l-3.203 62.661 3.593 122.709 25.527 91.341s-21.959-6.953-33.766-35.985"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient364)",
    stroke: "none",
    d: "M1193.93 961.321c-5.612-3.871-5.806-17.42-4.258-17.42 1.549 0 21.484 10.065 23.226 12.968 1.742 2.904-1.355 4.258-1.355 4.258l9.871 6s.58 8.323 0 8.903c-.581.582-3.29 1.162-3.29 1.162s-18.582-12.001-24.194-15.871"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath374)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1221.672 974.998)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ae1b0f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-15.097-11.742s4.517-1.161 5.29-2.71C-9.032-16-32.722-29.431-32.722-29.431s-.251-1.949.722-1.666c.973.284 21.807 10.839 23.226 12.968 1.42 2.129-.387 4.581-.387 4.581l8.903 5.677z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient400)",
    stroke: "none",
    d: "M1266.575 1151.288c-.515-.226-14.968-74.096-14.968-74.096l-16.354-55.226 5.033 1.935 14.503 13.428 35.012 17.927 48.903 63.322v44.42l-41.935 3.29s-29.677-14.774-30.194-15"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient424)",
    stroke: "none",
    d: "M1222.962 1088.192s-2.272-150.871 6.606-193.839l3.458-7.613s-3.87 107.613 2.581 122.323c6.452 14.71 10.582 21.677 22.968 27.87 12.387 6.194 52.387 17.808 80.129 18.323v79.742s-15.871 2.452-22.064-8.194c-6.194-10.645-23.919-60.451-30.023-65.096-6.106-4.645-45.028-34.839-46.987-35.355-1.958-.516 17.978 28.903 20.784 35.613 2.807 6.71 7.645 87.29 7.645 87.29l2.903 9.291-6.064 2.515z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 1161.192)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de6c57",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-41.612.548-70.354-12.516l-.291.58 12.581 8.42s34.354 8.613 34.645 8.613C-23.129 5.097 0 3.161 0 3.161z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 1152.546)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d42b0a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-35.612-.774-49.161-4.645c0 0-9.936-3.193-5.936 0s6.226 3.387 6.226 3.387 13.549 4.742 14.323 4.742c.774 0 17.903 3 19.741 2.516C-12.968 5.516 0 4.162 0 4.162z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 1162.998)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad170c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-49.25.069-70.645-13.742c0 0 2.129 6-2.709 9.29-4.839 3.291 9.483 5.614 9.483 5.614l17.226 5.419 32.129 5.613L0 9.291z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.704 1155.256)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70131a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.193s-26.839.387-40.904-7.355c0 0 1.161 4.774 9.161 8.129 8 3.355 32 5.162 45.936 5.162z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient470)",
    stroke: "none",
    d: "M1249.693 1159.901c-24.064-15.544-26.731-71.709-26.731-71.709l4.645 2.936 8.322 3.936s6.13 19.547 7.936 26.257c1.807 6.709 21.033 29.161 21.935 30.838.904 1.678-.45 6.388-.45 6.388s-.839 2.515-.452 2.515c.387 0 21.719 14.957 21.719 14.957s-18.945-4.505-36.924-16.118"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath480)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1235.253 1095.025)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33383d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-7.646-3.897s.212 31.133 12.678 51.87c5.17 8.601 13.661 14.028 23.194 16.903 0 0 1.161-4.109.645-5.99-.517-1.881-3.226-7.429-8.13-12.848-4.902-5.419-11.483-12.256-15.096-24.515C2.032 9.264 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1249.693 1138.07)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25292d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-6.989-7.718-8.408-11.266c-1.42-3.548-7.807-29.613-7.807-29.613s-3.846-2.507-3.91-2.128c-.064.38 2.73 14.752 2.73 14.752s1.183 2.989 1.279 3.376c.095.387 1.334 5.677 1.037 6.065-.297.387 0 3.653 0 3.653l.639 3.895 4.377 6.645L-6.344 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260.414 1151.289)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ea3a0",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s.774 2.806 0 2.613c-.774-.194-15.29-7.161-18-11.42-2.71-4.257-7.161-15.677-7.161-15.677l2.612.774s1.356 4.344 2.129 5.269c.774.925 8.011 5.473 8.011 5.473s7.763 9 8.151 9.194C-3.871-3.581 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1235.93 1118.579)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ea3a0",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-1.838l-4.523-23.515s2.596.671 2.447 1.206C-4.064-21.774 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1240.285 1133.192)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#696a6d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s2.419-.774 3.58 0 9.871 8.129 10.452 9.581c.58 1.451 6.097 8.516 6.097 8.516s-5.613-3.775-6.775-5.129C12.193 11.613 2.129 1.742 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient520)",
    stroke: "none",
    d: "M1302.511 1180.417c-12.387-1.935-39.032-13.29-39.032-13.29v-7.226c1.032.517 1.871-1.354 1.871-1.354 20.515 11.032 73.354 12.774 73.354 12.774v11.225c-6.386 0-23.807-.193-36.193-2.129"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath530)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1297.672 656.62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#linearGradient538)",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0s-47.187 118.278-51.871 139.258c-1.918 8.593-10.693 49.874-13.012 87.075-3.342 53.623 0 106.571 0 106.571"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath548)",
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261.017 754.385)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s3.365-27.645 8.01-37.709c4.645-10.064 11.46-30.953 5.124-28.517C6.797-63.79-26.791 34.578-29.713 32.606c-2.922-1.971 5.594-41.154 5.594-41.154s11.477-18.372 11.897-19.521c.42-1.15 20.232-48.988 20.232-48.988s3.097-5.942 3.097-7.878c0-1.935 25.303-17.931 25.303-17.931v5.732z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient580)",
    stroke: "none",
    d: "M1338.502 648.963l51.725-3.848 47.117 120.092s17.718 101.464 18.19 104.879c.472 3.414-1.031 98.964-1.031 98.964l-17.159 68.469-98.842 3.789z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath590)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1403.53 719.257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666768",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-5.501 91.048-4.361 94.033c1.139 2.986 11.14.921 11.14.921S17.577 61.106 19.568 58.93c1.992-2.177 4.209-23.281 0-29.757C15.359 22.696 0 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient616)",
    stroke: "none",
    d: "M1441.6 982.945c4.132-22.493-3.873-138.798-3.873-138.798l-16.738-5.658-1.585-.536v-5.161l16.344 5.419c-.432-12.387-10.666-50.581-11.44-51.203-.774-.624 5.678-6.345 5.678-6.345l19.096 75.355-2.267 96.774-2.398 36.718z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient640)",
    stroke: "none",
    d: "M1338.502 1035.373c38.838 0 62.838-10.839 79.097-18.065 16.258-7.226 17.29-26.323 16.644-27.798-.645-1.476-20.258-53.75-21.526-54.009-1.266-.258-59.119 5.162-61.183 6.194s-4.645 10.322-5.42 12.345c-.774 2.023-7.612 1.074-7.612 1.074v-24.516s76.773-10.58 78.322-9.806c1.548.774 21.161 56.008 21.161 56.008l6.444 17.541s-.508 30.451-.012 31.999c.496 1.548-15.464 19.355-15.464 19.355l-90.451 12.387z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient664)",
    stroke: "none",
    d: "M1338.502 672.921v-16.314s34.916 1.038 42.246 3.052c7.331 2.013 5.182 13.987 5.182 13.987s-33.106-.725-47.428-.725"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient684)",
    stroke: "none",
    d: "M1419.303 934.699s.076-9.778-15.008-6.681c-15.084 3.096-28.439 6.681-67.923 6.681l2.13-122.362 27.483 1.874s37.549 2.789 42.194-5.186c4.645-7.976 9.096-50.555 9.096-50.555l10.259 8.101-.091 16.519s-8.039 64.411-8.039 74.476c0 10.065-.774 49.161 1.935 67.355 2.711 18.194 23.078 64.589 23.078 64.589v7.532z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath694)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 641.308)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d64829",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l20.773 3.807s21.936-2.323 22.968-1.904c1.032.42 30.968-3.193 32.517-3.71 1.548-.515 4.644-5.934 4.644-5.934S59.741-17.807 48.129-20.387c-11.613-2.581-46.091-3.336-46.091-3.336L0-22.451z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 655.114)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d52d19",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h40.451s37.936 97.355 38.322 103.355c0 0-4.062 41.807-6.966 46.645-2.905 4.839 1.934 7.223-71.807 7.223v1.874s57.981.581 58.562.387c.581-.193 12.664.58 15.374-10.258 2.709-10.839 6.966-48.581 6.966-48.581L61.936 22.201 41.032-4.258S47.741.903 48-3.613c.258-4.516-1.389-6.513-4.646-7.355-3.257-.841-11.742-.121-13.786.079-2.044.201-17.698 4.179-19.246 4.179C8.773-6.71 0-4.258 0-4.258z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 653.13)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2988a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h38.709S38.451-3.822 36-5.758c-2.452-1.935-1.291-2.451.129-2.451 1.419 0 3.225.646 3.612 0 .388-.645 8 5.936 4.646 5.936-3.355 0-3.441-.227-3.11.649.331.876 15.496 16.77 16.529 17.157C58.838 15.92 64 19.791 64 19.791l2.58-3.484s.774-1.29 0-1.936c-.774-.644-2.839.388-1.678-1.29 1.162-1.677 33.807-18.58 33.936-20.774.13-2.194-3.783-8.253-7.892-10.578-4.108-2.325-30.173-9.292-30.173-9.292L0-35.822l.258 4.129s78.839 9.677 77.032 12.645c-1.807 2.968-18.193 2.322-23.871 4-5.678 1.678-9.678 4-16.774 4.129-7.097.129-19.613-2.064-36.645-2.064z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient724)",
    stroke: "none",
    d: "M1440.308 745.825c-3.097-1.033-22.968-16.776-22.968-16.776s-6.624-46.233-7.014-47.088c-.389-.853 5.866-2.912 5.522-5.557-.346-2.644 27.557-18.064 27.557-18.064l5.914-5.21c.756 1.727 12.409 40.823 12.409 40.823l-9.302 45.161s-7.929 6.805-11.472 6.805c-.236 0-.453-.03-.646-.094"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1408.179 677.315)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e99c8f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s42.529-19.716 45.556-29.943c0 0 .166-6.556-1.308-9.181-1.474-2.625.422-2.238 1.313-1.271.891.968 3.107 12.968 3.257 13.936.15.968-9.05 5.896-9.05 5.896S10.259-1.491 4.064.831c0 0 17.033 47.226 18.968 49.742 1.936 2.516 5.032 8.323 8.71 0 3.678-8.322 6.238-9.096 6.894-24.774.655-15.678-1.668-24.452 2.01-22.839 3.677 1.613 6.193 10.645 6.193 10.645l6.774 20.129s2.129 26.517 1.355 28.065c-.775 1.549-7.548 13.935-7.548 13.935s-5.807 23.42-6 24.388c-.194.967-5.807 15.483-5.807 15.483l-9.677-23.612L2.323 22.509 0 3.153z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient760)",
    stroke: "none",
    d: "M1446.815 829.437s-3.41-34.58-1.66-40.025c1.752-5.444 5.217-18.297 5.991-29.653.775-11.355 6.453-15.742 8.258-24.516 1.807-8.775-11.548-78.967-11.548-78.967 7.807-4.387 8.969-10.323 5.878-16.516-3.091-6.193-22.459-4.388-22.459-4.388s-32-9.032-45.161-12.129c-13.161-3.096-47.612-3.355-47.612-3.355v-5.677c62.065 0 79.097 9.032 84.596 11.096 5.5 2.065 16.178 0 20.565 0 4.387 0 10.84 6.582 10.84 6.582 7.229 14.322 9.418 40.257 14.063 71.225 4.645 30.968-2.71 96.387-3.871 109.223-1.161 12.836 0 122.362 0 122.362z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath770)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1447.082 790.985)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#434548",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.968 15.097.774 20.516c1.743 5.42 4.005 11.42 6.648 11.032 2.642-.387 6.127-1.741 6.127-8.516 0-6.774-.194-48 0-48.58.193-.581-.775-8.71-4.452 0C5.42-16.839 1.169-5.078 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1447.856 796.985)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23272b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s4.779-8.323 6.647-8.709c1.869-.388 3.224 23.225 2.063 24C7.548 16.064.193 9.484 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456.997 763.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#696e6f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s1.505 20.705 1.311 24.581c-.194 3.875.21 27.941-.647 30.778-.856 2.837.911 1.647 1.587.757 3.222-4.241 1.298-40.047 1.298-40.047S4.058-.458 3.067-1.357C2.076-2.257 1.169-2.584 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient806)",
    stroke: "none",
    d: "M1444.457 1073.566l3.593-122.71-3.204-62.66s-4.538-60.823-13.442-92.332c-8.902-31.508-51.87-145.007-51.87-145.007s17.419 15.87 20.129 18.579c2.709 2.71 5.419 0 5.419 0s1.936 5.42 3.097 7.88c1.161 2.458 32.129 67.992 37.161 113.67 5.032 45.676 19.355 143.713 19.355 143.713s-1.549 83.125 1.161 107.899-1.354 57.29-13.161 86.323c-11.807 29.032-33.765 35.985-33.765 35.985z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient830)",
    stroke: "none",
    d: "M1455.792 976.018c-.581-.581 0-8.904 0-8.904l9.871-5.999s-3.096-1.356-1.356-4.258c1.743-2.904 21.678-12.969 23.227-12.969 1.548 0 1.355 13.549-4.258 17.42-5.613 3.871-24.194 15.871-24.194 15.871s-2.71-.581-3.29-1.161"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath840)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455.534 974.985)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ae1b0f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l15.097-11.742s-4.517-1.161-5.291-2.71C9.032-16 32.722-29.431 32.722-29.431s.25-1.949-.722-1.666c-.973.284-21.807 10.839-23.227 12.968-1.419 2.129.388 4.581.388 4.581L.258-7.871z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient866)",
    stroke: "none",
    d: "M1338.502 1162.985v-44.419l48.902-63.323 35.012-17.926 14.505-13.428 5.032-1.936-16.355 55.225s-14.452 73.872-14.967 74.098c-.516.225-30.194 15-30.194 15z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient890)",
    stroke: "none",
    d: "M1406.243 1158.534l2.903-9.291s4.839-80.58 7.646-87.29c2.807-6.71 22.742-36.129 20.783-35.613-1.958.517-40.879 30.71-46.985 35.355-6.106 4.646-23.83 54.452-30.024 65.097-6.194 10.645-22.064 8.193-22.064 8.193v-79.742c27.741-.516 67.741-12.129 80.128-18.322 12.387-6.194 16.516-13.162 22.968-27.872 6.452-14.708 2.581-122.322 2.581-122.322l3.458 7.613c8.879 42.968 6.606 193.838 6.606 193.838l-41.935 72.871z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath900)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 1161.179)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de6c57",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s41.612.548 70.354-12.516l.291.58-12.581 8.42S23.709 5.097 23.419 5.097C23.129 5.097 0 3.162 0 3.162z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 1152.534)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d42b0a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s35.612-.774 49.161-4.645c0 0 9.936-3.194 5.936 0-4 3.193-6.227 3.387-6.227 3.387S35.322 3.484 34.548 3.484c-.775 0-17.903 3-19.742 2.516C12.968 5.516 0 4.161 0 4.161z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 1162.985)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad170c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s49.25.069 70.645-13.742c0 0-2.129 6 2.709 9.29 4.839 3.291-9.484 5.613-9.484 5.613l-17.225 5.42-32.129 5.612L0 9.291z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.502 1155.243)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70131a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h14.193s26.839.387 40.904-7.354c0 0-1.161 4.773-9.161 8.128-8 3.355-32 5.162-45.936 5.162z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient936)",
    stroke: "none",
    d: "M1412.308 1161.049c.387 0-.452-2.515-.452-2.515s-1.354-4.71-.452-6.387c.904-1.678 20.13-24.129 21.936-30.839 1.806-6.71 7.935-26.256 7.935-26.256l8.324-3.938 4.644-2.936s-2.666 56.167-26.731 71.71c-17.978 11.613-36.922 16.119-36.922 16.119s21.331-14.958 21.718-14.958"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath946)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1441.953 1095.012)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33383d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l7.646-3.898S7.434 27.236-5.032 47.973c-5.17 8.601-13.661 14.028-23.194 16.903 0 0-1.161-4.109-.645-5.99.517-1.881 3.225-7.429 8.129-12.848 4.903-5.42 11.484-12.256 15.096-24.515C-2.032 9.264 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1427.513 1138.058)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25292d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s6.989-7.718 8.408-11.266c1.419-3.549 7.807-29.613 7.807-29.613s3.846-2.507 3.91-2.128c.064.38-2.73 14.751-2.73 14.751s-1.183 2.99-1.279 3.377c-.095.387-1.335 5.677-1.037 6.064.297.387 0 3.654 0 3.654l-.639 3.895-4.377 6.645L6.344 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1416.792 1151.276)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ea3a0",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.774 2.806 0 2.613c.774-.194 15.29-7.162 18-11.42 2.71-4.258 7.161-15.677 7.161-15.677l-2.613.774s-1.355 4.344-2.129 5.269c-.773.924-8.011 5.473-8.011 5.473s-7.762 9-8.15 9.194C3.871-3.581 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1441.275 1118.566)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ea3a0",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h1.839l4.523-23.515s-2.596.671-2.447 1.206C4.064-21.774 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1436.92 1133.179)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#696a6d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-2.419-.774-3.581 0c-1.161.774-9.87 8.129-10.451 9.581-.581 1.451-6.097 8.516-6.097 8.516s5.612-3.774 6.775-5.129C-12.193 11.613-2.129 1.742 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient986)",
    stroke: "none",
    d: "M1338.502 1171.308s52.838-1.742 73.354-12.774c0 0 .839 1.871 1.871 1.354v7.227s-26.645 11.354-39.032 13.29c-12.388 1.935-29.806 2.128-36.193 2.128z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1379.534 656.606)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#linearGradient1004)",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0s47.187 118.278 51.87 139.257c1.919 8.594 10.694 49.875 13.013 87.076 3.342 53.623 0 106.57 0 106.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1014)",
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1416.19 754.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-3.365-27.644-8.011-37.708c-4.644-10.065-11.46-30.954-5.123-28.518 6.337 2.436 39.925 100.804 42.847 98.832 2.922-1.971-5.595-41.153-5.595-41.153S12.642-26.919 12.222-28.069c-.42-1.149-20.233-48.987-20.233-48.987s-3.096-5.944-3.096-7.879c0-1.936-25.303-17.931-25.303-17.931v5.733z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1030)",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1034)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1050)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1070)",
    stroke: "none",
    d: "M1453.734 1058.095s-36.167 16.839-39.119 18.348c0 0 2.145-20.897 12.241-31.629 0 0-3.322-3.988-7.452 2.188-4.129 6.177-10.258 8.241-10.258 8.241s14.149-15.972 13.27-17.927c-.878-1.954-29.203 17.774-34.123 27.266-4.92 9.492-9.34 19.468-9.34 19.468s-2.903-1.452-15.807-5.581c-12.903-4.129-47.483-3.613-56.257-4.129-8.775-.516-9.217 9.71-9.217 9.71s-5.368-14.765-8.212-18.553c-2.844-3.789-39.11-31.513-39.11-31.513s7.449 13.031 13.129 13.809c5.679.778 16.845 20.87 17.224 28.096.379 7.225 5.038 25.29 5.038 25.29s-5.691-25.29-8.788-29.42c-3.097-4.129-6.451-14.709-11.354-18.838-4.904-4.129-16.348-14.968-17.594-16-1.245-1.032-4.408-2.937-4.408-2.937l16.817 27.982 3.065 21.664s-4.507-7.825-13.129-10.687c-8.622-2.861-19.443-10.216-22.743-12.538-3.299-2.323-4.905-4.259-4.905-4.259s.245-53.342.472-64.024l4.433 2.218 2.785 27.613.912-21.154s.23 7.477 6.424 14.702c6.193 7.226 14.389 20.187 26.528 23.905 11.762 3.603 44.762 17.328 72.116 15.78 27.356-1.549 45.965-1.878 71.358-13.865 25.393-11.988 34.424-29.417 36.727-40.522 2.303-11.104 2.222-78.473.972-96.272-1.25-17.8-3.166-43.631-3.166-43.631s8.109 34.956 7.336 46.006c-.775 11.051 3.418 143.72 4.135 151.193"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1096)",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1100)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1116)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1136)",
    stroke: "none",
    d: "M1290.982 924.227c17.971.436 34.01 9.047 49.991 6.032 15.98-3.016 60.084-4.819 63.322-8.304 3.239-3.486 8.899-58.518-2.705-78.744-11.605-20.226-23.476-14.729-32.766-22.381-9.29-7.651-64.516-4.906-66.064 1.721-1.549 6.628 8.258 31.869 5.678 38.345-2.582 6.477-19.586-26.556-22.697-27.072-3.11-.516 1.019 43.839-3.11 56.242-4.129 12.403-2.488 32.783-2.488 32.783z"
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacer1);
export default __webpack_public_path__ + "static/media/racer1.1dcf168b.svg";
export { ForwardRef as ReactComponent };